"use strict";
'use es6'; // See https://git.hubteam.com/HubSpot/IdentityBase/blob/master/src/main/protobuf/properties.proto
// In alphabetical order

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WORKFLOWS = exports.WAL_INCREMENTAL = exports.TASK = exports.TALLY = exports.SUCCESS = exports.SOCIAL = exports.SIGNALS = exports.SIDEKICK = exports.SEQUENCES = exports.SALESFORCE = exports.SALES_MESSAGES = exports.SALES = exports.RECYCLING_BIN = exports.QUOTAS = exports.QUOTES = exports.PRESENTATIONS = exports.PORTAL_USER_ASSOCIATOR = exports.MOBILE_IOS = exports.MOBILE_ANDROID = exports.MIGRATION = exports.MERGE_OBJECTS = exports.MERGE_CONTACTS = exports.MERGE_COMPANIES = exports.MEETINGS = exports.LEADIN = exports.INTEGRATIONS_SYNC = exports.INTEGRATIONS_PLATFORM = exports.INTEGRATION = exports.IMPORT = exports.HEISENBERG = exports.GMAIL_INTEGRATION = exports.FORWARD_TO_CRM = exports.FORM = exports.EXTENSION = exports.ENGAGEMENTS = exports.EMAIL_INTEGRATION = exports.EMAIL = exports.DEFAULT = exports.DEALS = exports.CRM_UI = exports.COMPANIES = exports.CONVERSATIONS = exports.CONTENT_MEMBERSHIP = exports.CONTACTS_WEB = exports.CONTACTS = exports.COMPANY_FAMILIES = exports.CALCULATED = exports.BOT = exports.BIDEN = exports.BET_CRM_CONNECTOR = exports.BET_ASSIGNMENT = exports.BCC_TO_CRM = exports.BATCH_UPDATE = exports.AVATARS_SERVICE = exports.AUTOMATION_PLATFORM = exports.ASSOCIATIONS = exports.ASSISTS = exports.API = exports.ANALYTICS = exports.ACADEMY = void 0;
var ACADEMY = 'ACADEMY';
exports.ACADEMY = ACADEMY;
var ANALYTICS = 'ANALYTICS';
exports.ANALYTICS = ANALYTICS;
var API = 'API';
exports.API = API;
var ASSISTS = 'ASSISTS';
exports.ASSISTS = ASSISTS;
var ASSOCIATIONS = 'ASSOCIATIONS';
exports.ASSOCIATIONS = ASSOCIATIONS;
var AUTOMATION_PLATFORM = 'AUTOMATION_PLATFORM';
exports.AUTOMATION_PLATFORM = AUTOMATION_PLATFORM;
var AVATARS_SERVICE = 'AVATARS_SERVICE';
exports.AVATARS_SERVICE = AVATARS_SERVICE;
var BATCH_UPDATE = 'BATCH_UPDATE';
exports.BATCH_UPDATE = BATCH_UPDATE;
var BCC_TO_CRM = 'BCC_TO_CRM';
exports.BCC_TO_CRM = BCC_TO_CRM;
var BET_ASSIGNMENT = 'BET_ASSIGNMENT';
exports.BET_ASSIGNMENT = BET_ASSIGNMENT;
var BET_CRM_CONNECTOR = 'BET_CRM_CONNECTOR';
exports.BET_CRM_CONNECTOR = BET_CRM_CONNECTOR;
var BIDEN = 'BIDEN';
exports.BIDEN = BIDEN;
var BOT = 'BOT';
exports.BOT = BOT;
var CALCULATED = 'CALCULATED';
exports.CALCULATED = CALCULATED;
var COMPANY_FAMILIES = 'COMPANY_FAMILIES';
exports.COMPANY_FAMILIES = COMPANY_FAMILIES;
var CONTACTS = 'CONTACTS';
exports.CONTACTS = CONTACTS;
var CONTACTS_WEB = 'CONTACTS_WEB';
exports.CONTACTS_WEB = CONTACTS_WEB;
var CONTENT_MEMBERSHIP = 'CONTENT_MEMBERSHIP';
exports.CONTENT_MEMBERSHIP = CONTENT_MEMBERSHIP;
var CONVERSATIONS = 'CONVERSATIONS';
exports.CONVERSATIONS = CONVERSATIONS;
var COMPANIES = 'COMPANIES';
exports.COMPANIES = COMPANIES;
var CRM_UI = 'CRM_UI';
exports.CRM_UI = CRM_UI;
var DEALS = 'DEALS';
exports.DEALS = DEALS;
var DEFAULT = 'DEFAULT';
exports.DEFAULT = DEFAULT;
var EMAIL = 'EMAIL';
exports.EMAIL = EMAIL;
var EMAIL_INTEGRATION = 'EMAIL_INTEGRATION';
exports.EMAIL_INTEGRATION = EMAIL_INTEGRATION;
var ENGAGEMENTS = 'ENGAGEMENTS';
exports.ENGAGEMENTS = ENGAGEMENTS;
var EXTENSION = 'EXTENSION';
exports.EXTENSION = EXTENSION;
var FORM = 'FORM';
exports.FORM = FORM;
var FORWARD_TO_CRM = 'FORWARD_TO_CRM';
exports.FORWARD_TO_CRM = FORWARD_TO_CRM;
var GMAIL_INTEGRATION = 'GMAIL_INTEGRATION';
exports.GMAIL_INTEGRATION = GMAIL_INTEGRATION;
var HEISENBERG = 'HEISENBERG';
exports.HEISENBERG = HEISENBERG;
var IMPORT = 'IMPORT';
exports.IMPORT = IMPORT;
var INTEGRATION = 'INTEGRATION';
exports.INTEGRATION = INTEGRATION;
var INTEGRATIONS_PLATFORM = 'INTEGRATIONS_PLATFORM';
exports.INTEGRATIONS_PLATFORM = INTEGRATIONS_PLATFORM;
var INTEGRATIONS_SYNC = 'INTEGRATIONS_SYNC';
exports.INTEGRATIONS_SYNC = INTEGRATIONS_SYNC;
var LEADIN = 'LEADIN';
exports.LEADIN = LEADIN;
var MEETINGS = 'MEETINGS';
exports.MEETINGS = MEETINGS;
var MERGE_COMPANIES = 'MERGE_COMPANIES';
exports.MERGE_COMPANIES = MERGE_COMPANIES;
var MERGE_CONTACTS = 'MERGE_CONTACTS';
exports.MERGE_CONTACTS = MERGE_CONTACTS;
var MERGE_OBJECTS = 'MERGE_OBJECTS';
exports.MERGE_OBJECTS = MERGE_OBJECTS;
var MIGRATION = 'MIGRATION';
exports.MIGRATION = MIGRATION;
var MOBILE_ANDROID = 'MOBILE_ANDROID';
exports.MOBILE_ANDROID = MOBILE_ANDROID;
var MOBILE_IOS = 'MOBILE_IOS';
exports.MOBILE_IOS = MOBILE_IOS;
var PORTAL_USER_ASSOCIATOR = 'PORTAL_USER_ASSOCIATOR';
exports.PORTAL_USER_ASSOCIATOR = PORTAL_USER_ASSOCIATOR;
var PRESENTATIONS = 'PRESENTATIONS';
exports.PRESENTATIONS = PRESENTATIONS;
var QUOTES = 'QUOTES';
exports.QUOTES = QUOTES;
var QUOTAS = 'QUOTAS';
exports.QUOTAS = QUOTAS;
var RECYCLING_BIN = 'RECYCLING_BIN';
exports.RECYCLING_BIN = RECYCLING_BIN;
var SALES = 'SALES';
exports.SALES = SALES;
var SALES_MESSAGES = 'SALES_MESSAGES';
exports.SALES_MESSAGES = SALES_MESSAGES;
var SALESFORCE = 'SALESFORCE';
exports.SALESFORCE = SALESFORCE;
var SEQUENCES = 'SEQUENCES';
exports.SEQUENCES = SEQUENCES;
var SIDEKICK = 'SIDEKICK';
exports.SIDEKICK = SIDEKICK;
var SIGNALS = 'SIGNALS';
exports.SIGNALS = SIGNALS;
var SOCIAL = 'SOCIAL';
exports.SOCIAL = SOCIAL;
var SUCCESS = 'SUCCESS';
exports.SUCCESS = SUCCESS;
var TALLY = 'TALLY';
exports.TALLY = TALLY;
var TASK = 'TASK';
exports.TASK = TASK;
var WAL_INCREMENTAL = 'WAL_INCREMENTAL';
exports.WAL_INCREMENTAL = WAL_INCREMENTAL;
var WORKFLOWS = 'WORKFLOWS';
exports.WORKFLOWS = WORKFLOWS;